import { englishServiceFactories } from './english';
// 다른 서비스팩토리가 있다면 아래처럼 import
// import { xxxServiceFactories } from './xxx';
// 기존 호환성을 위해 필요한 개별 심볼도 유지
import { VideoItemService } from './english/VideoItemService';
import { TextTranslationService } from './english/TextTranslationService';
import { AutoTranslationService } from './english/AutoTranslationService';
import { DictionaryService } from './english/DictionaryService';
import { VoiceService } from './english/VoiceService';
import { OllamaService } from './OllamaService';
import { StockService } from './stock/StockService';
import { LottoService } from './lotto/LottoService';
import { BuybackService } from './buyback/BuybackService';
import { TossService } from './toss/TossService';
import { YahooFinanceService } from './yahoo/YahooFinanceService';
import { GpuRentalService } from './gpu/GpuRentalService';
import { RamPriceService } from './ram-price/RamPriceService';
import OllamaServiceFactory from './OllamaService';
import StockServiceFactory from './stock/StockService';
import LottoServiceFactory from './lotto/LottoService';
import BuybackServiceFactory from './buyback/BuybackService';
import TossServiceFactory from './toss/TossService';
import YahooFinanceServiceFactory from './yahoo/YahooFinanceService';
import GpuRentalServiceFactory from './gpu/GpuRentalService';
import RamPriceServiceFactory from './ram-price/RamPriceService';
// 모든 서비스팩토리 집합: 확장에 따라 추가
export const serviceFactories = [
    ...englishServiceFactories,
    OllamaServiceFactory,
    StockServiceFactory,
    LottoServiceFactory,
    BuybackServiceFactory,
    TossServiceFactory,
    YahooFinanceServiceFactory,
    GpuRentalServiceFactory,
    RamPriceServiceFactory,
    // ...xxxServiceFactories, // 추가 가능
];
export const defineServices = async (container) => {
    serviceFactories.forEach(factory => factory(container));
};
export { VideoItemService, TextTranslationService, AutoTranslationService, DictionaryService, VoiceService, OllamaService, StockService, LottoService, BuybackService, TossService, YahooFinanceService, GpuRentalService, RamPriceService, };
